import type { DefaultTheme } from 'styled-components';

export const createPDPScrollHandler = (theme: DefaultTheme) => {
  let previousScrollY = window.scrollY;
  let previousTopValue = 0;
  const topNavHeight = Number.parseInt(theme.variables.topNavHeight, 10);
  const uspBarHeight = Number.parseInt(theme.variables.uspBarHeight, 10);
  const topOffset = uspBarHeight + topNavHeight;

  return () => {
    const imageGallery = document.querySelector('.product-image-gallery')?.parentElement;
    const productDetails = imageGallery?.nextElementSibling as HTMLElement;

    if (!imageGallery || !productDetails) {
      return;
    }

    const imageGalleryHeight = imageGallery.getBoundingClientRect().height;
    const productDetailsHeight = productDetails.getBoundingClientRect().height;

    if (imageGalleryHeight === productDetailsHeight) {
      return;
    }

    const { scrollTop } = document.documentElement;
    const scrollDirection = window.scrollY > previousScrollY ? 'down' : 'up';
    const shortColumn = imageGalleryHeight < productDetailsHeight ? imageGallery : productDetails;
    const longColumn = imageGalleryHeight < productDetailsHeight ? productDetails : imageGallery;
    const heightDifference =
      topOffset + Math.min(imageGalleryHeight, productDetailsHeight) - window.innerHeight;
    const bottomOffset = heightDifference - uspBarHeight;

    if (heightDifference < 0) {
      previousTopValue = topOffset;
      shortColumn.style.top = `${Math.abs(previousTopValue)}px`;
    } else {
      previousTopValue -= previousScrollY - window.scrollY;

      if (previousTopValue < 0) {
        if (scrollDirection === 'up' && previousTopValue < -1 * topOffset) {
          previousTopValue = -1 * topOffset;
        }

        shortColumn.style.top = `${Math.abs(previousTopValue)}px`;
      } else {
        if (scrollDirection === 'down' && previousTopValue > bottomOffset) {
          previousTopValue = bottomOffset;
        }

        shortColumn.style.top = `-${previousTopValue}px`;
      }
    }

    shortColumn.style.position = 'sticky';
    longColumn.style.top = '';
    longColumn.style.position = '';
    previousScrollY = scrollTop;
  };
};
